import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { ResponseModel } from '../models/api.model';

import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';


@Injectable()
export class OrderService extends BaseService {

  constructor(private http: HttpClient, private router: Router, messageService: MessageService) {
    super(messageService);

  }

  add(order: any) {
    const sanitizedOrder = this.sanitizePayload(order);
    return this.http.post(`${environment.baseUrl}api/order/add`, sanitizedOrder)
      .pipe(map(res => {
        if (res != null)
          return <ResponseModel<any>>res;
      }));
  }

  edit(form: any) {
    const sanitizedForm = this.sanitizePayload(form);
    return this.http.post(`${environment.baseUrl}api/order/edit`, sanitizedForm)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  getEdit(id: string) {
    return this.http.get(`${environment.baseUrl}api/order/edit/${id}`)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  getEditNew() {
    return this.http.get(`${environment.baseUrl}api/order/editnew`)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  createOrderFromTenders(mergeTenderReqObj: object) {
    const sanitizedObj = this.sanitizePayload(mergeTenderReqObj);
    return this.http.post(`${environment.baseUrl}api/order/mergetenders`, sanitizedObj)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  getBulkEdit(orderIds: any) {
    let p = new HttpParams({ fromObject: { orderIds } });
    return this.http.get(`${environment.baseUrl}api/detail/BulkOrder`, { params: p })
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  saveBulkEdit(form: any) {
    const sanitizedForm = this.sanitizePayload(form);
    return this.http.post(`${environment.baseUrl}api/order/BulkEdit`, sanitizedForm)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }

  revertOrder(revertOrderObject: object) {
    const sanitizedObj = this.sanitizePayload(revertOrderObject);
    return this.http.post(`${environment.baseUrl}api/order/RevertOrder`, sanitizedObj)
      .pipe(map(res => {
        return <ResponseModel<any>>res;
      }));
  }
}
